import { render, staticRenderFns } from "./MarketingChargeEdit.vue?vue&type=template&id=08d33fa0&scoped=true&"
import script from "./MarketingChargeEdit.vue?vue&type=script&lang=js&"
export * from "./MarketingChargeEdit.vue?vue&type=script&lang=js&"
import style0 from "./MarketingChargeEdit.vue?vue&type=style&index=0&id=08d33fa0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d33fa0",
  null
  
)

export default component.exports